import { useState } from 'react';
import { Share2, Check } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Builds a backend share URL that unfurls correctly on WhatsApp/LinkedIn/Facebook
// (crawlers read Open Graph tags; real visitors are redirected to the profile).
export const ShareButton = ({ type, id, title, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = `${BACKEND_URL}/api/share/${type}/${id}`;

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: title || 'Campia', url: shareUrl });
        return;
      }
    } catch (_) {
      // user cancelled native share — fall through to copy
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success('Share link copied', {
        description: 'Paste it into WhatsApp, LinkedIn or Facebook — it unfurls with a preview card.',
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      toast.error('Could not copy link');
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleShare}
      className={`gap-2 ${className}`}
      data-testid={`share-${type}-button`}
    >
      {copied ? <Check className="w-4 h-4" /> : <Share2 className="w-4 h-4" />}
      {copied ? 'Copied' : 'Share'}
    </Button>
  );
};

export default ShareButton;
